import script from "./linkService.vue?vue&type=script&setup=true&lang=js"
export * from "./linkService.vue?vue&type=script&setup=true&lang=js"

import "./linkService.vue?vue&type=style&index=0&id=c33cbd76&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c33cbd76"]])

export default __exports__